<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <el-dropdown class="avatar-container" trigger="click">
       <div class="avatar-wrapper">
        <span>{{userName}}</span>
          <!-- <el-select
            v-model="hospital.hospitalId"
            clearable
            placeholder="全部医疗机构数据"
            @change="setHospitalId"
          >
            <el-option
              v-for="item in hospitals"
              :key="item.hospitalId"
              :label="item.hospitalName"
              :value="item.hospitalId"
            />
          </el-select> -->

					<i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided v-if="forbidden">
            <el-button type="text" @click="changePassword" style="display: block;color: #606266;">修改密码</el-button>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logOut" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>

    <!-- 修改密码弹框 -->
    <forgot-passwords :phoneNumber="phoneNumber" :isShow="dialogVisible" @changePasswordDialogClose="dialogClose"></forgot-passwords>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import ForgotPasswords from "@/views/forgotpassword/forgotpasswords";   // 修改密码弹框
import { login, logout } from "@/api/login";

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ForgotPasswords
  },
  
  data() {
    return {
      dialogVisible: false,
      phoneNumber: "",
      userName: "",
      hospitals: [],
      hospital: {
        hospitalId: null
      },
      forbidden: true,
    };
  },
  created() {
    this.userName = localStorage.getItem("username");
    if(localStorage.getItem("username") == "TEST管理员") {
      this.forbidden = false;
    } else {
      this.forbidden = true;
    }
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "username"])
  },
  methods: {
    changePassword() {
      this.dialogVisible = true;
    },

    dialogClose() {
      this.dialogVisible = false;
    },
    
    setHospitalId() {
      sessionStorage .setItem("hospitalId", this.hospital.hospitalId);
      location.reload();
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logOut() {
      /*this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })*/
      sessionStorage .removeItem("username");
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue